// @flow

import type { PropsSchema, BasicProps } from '../../type'
import type { Visitor } from 'projects/easy/public/type'


import * as React from 'react'
import computeData from '../hoc/computeData'

import DatePicker from 'antd-mobile/lib/date-picker';
import 'antd-mobile/dist/antd-mobile.css';


type Props = BasicProps & {
  style: { [string]: string },
  field: string,
  visitor: Visitor,
  minDate: number,
  maxDate: number,
  popupTitle: string,
  extra: string,
  query: { [string]: string },
  setFormValues: ({ [key: string]: any }) => void,
   formValues:{ [string]: string },
mode:string,
};

const CustomChildren = ({ extra, onClick, style }) => (
  <div
    onClick={onClick}
    style={{...style}}
  >
    <span>{extra}</span>
  </div>
);

@computeData()
export default class FormDateInput extends React.PureComponent<Props, {}> {
  static defaultProps = {
    type: 'text'
  };

  constructor (props: Props) {
    super(props)
  }

  static schema: PropsSchema = [
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      key: 'mode',
      title: '类型',
      type: 'select',
      options: [
        ['date', '日期'],
        ['time', '时间'],
        ['datetime', '日期+时间'],
        ['year', '年'],
        ['month', '月']
      ],
      defaultValue: 'date'
    },

    {
      key: 'minDate',
      title: '最小可选日期时间戳 字段',
      type: 'text'
    },
    {
      key: 'maxDate',
      title: '最大可选日期时间戳 字段',
      type: 'text'
    },
    {
      key: 'popupTitle',
      title: '弹窗标题',
      type: 'text'
    },
    {
      key: 'extra',
      title: '占位内容',
      type: 'text'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '选择完成',
      event: 'completeFn'
    }
  ];
    getFieldValue = (props?: Props): string => {
      const { field, formValues } = props || this.props
      return formValues[field] == null ? '' : formValues[field]
    };

    getMaxMinDate = (parameter:any,props?: Props): any => {
      const {formValues } = props || this.props
      return parameter ? formValues[parameter] == null ? '' : new Date(Number(formValues[parameter])):''
    };


  formatFn(time: string){
      const {mode}=this.props;
        if(!time){
            return '';
        }
        let date = new Date(time);//毫秒转换成日期
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2,'0');//月份不足两位数在前面补0
        return mode === 'year' ?  year :  year + '-' + month;//格式控制
  }
  onOkFn = (value:any) => {
    let values  = new Date(value).getTime();
    const { callActions } = this.props
    let { field, setFormValues } = this.props
    setFormValues({ [field]: values })
    callActions('completeFn',values)
  };
  componentDidMount () {
  }
  setFormat(){
    const {mode}=this.props
    if(mode === 'date'){
      return 'YYYY-MM-DD'
    }else if(mode === 'time'){
      return 'HH:mm'
    }
    else if(mode === 'datetime'){
      return 'YYYY-MM-DD HH:mm'
    }
  }
  render () {
    if (!this.props.visible) {
      return null
    }
    const {style,popupTitle,extra,maxDate,minDate,mode} = this.props;
    return (
      <div>
      <DatePicker
          mode={mode}
          title={popupTitle}
          maxDate = {this.getMaxMinDate(maxDate)}
          minDate = {this.getMaxMinDate(minDate)}
          extra={extra}
          value={this.getFieldValue() ? new Date(this.getFieldValue()) : ''}
          onOk={this.onOkFn}
          format={mode !== 'month' && mode !== 'year' ? this.setFormat() : this.formatFn.bind(this)}
        >
        <CustomChildren style={style}  extra='' onClick={()=>{}}></CustomChildren>
        </DatePicker>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormDateInput.js